import React from 'react';
import ProductListPage from 'rev.sdk.js/Templates/ProductList';
import * as CustomBrowse from '../../Utils/CustomBrowse';
import withPageEntry from '../../withPageEntry';
import TopFilter from './TopFilter';
import qs from 'query-string';
import {useOutlet} from 'reconnect.js';

function ProductList(props) {
  const params = qs.parse(props.location.search);
  const [dimension] = useOutlet('dimension');
  const isMobile = dimension.rwd === 'mobile';

  return (
    <React.Fragment>
      <TopFilter
        cat={params.cat}
        title_key={props.pageContext.title_key}
        categories={props.pageContext.outlets?.categories || 'categories'}
        prefixPath={props.pageContext.prefixPath || '/products'}
        params={params}
        mobile={isMobile}
      />
      <ProductListPage {...CustomBrowse.getExtraProductListProps(props)} />
    </React.Fragment>
  );
}

export default withPageEntry(ProductList);
